<script lang="ts">
	import { PUBLIC_BIXOTO_MEDIA } from '$env/static/public'
	import QtySelector from '$lib/helpers/QtySelector.svelte'
	import {
		getProductSpecialPriceWithTax,
		getProductRegularPriceWithTax,
		getProductTierPriceWithTax,
	} from '$lib/js/helpers'
	import { storeMiniCartModal, storeRemoveModal } from '$lib/js/stores'
	import type { CartProduct } from '$lib/js/types'
	import { getContextScope } from '$lib/js/helpers/i18n'
	import { getFormattedPrice } from '$lib/js/helpers/prices'

	export let product: CartProduct
	const scope = getContextScope()

	$: special_price = getProductSpecialPriceWithTax(product)
	$: regular_price = getProductRegularPriceWithTax(product)

	$: qty = product.cart_qty || 1

	/* Update price for tier prices */
	$: if (getProductTierPriceWithTax(product, qty)) {
		const tier_price = getProductTierPriceWithTax(product, qty)

		if (special_price && special_price < regular_price) {
			special_price = tier_price
		} else {
			regular_price = tier_price
		}
	} else {
		special_price = getProductSpecialPriceWithTax(product)
	}
</script>

<div class="cart-card">
	<div class="cart-card__inner">
		<button on:click={() => ($storeRemoveModal = product.item_id)} class="icon icon-cross" />

		<div class="cart-card__img">
			{#if product.resized_thumbnail}
				<img
					src="{PUBLIC_BIXOTO_MEDIA}{product.resized_thumbnail.path}"
					height={product.resized_thumbnail.height}
					width={product.resized_thumbnail.width}
					alt={product.name}
					title={product.name}
				/>
			{:else if product.cached_thumbnail}
				<!-- deprecated; keep it only for products cached in localStorage -->
				<img
					src="{PUBLIC_BIXOTO_MEDIA}{product.cached_thumbnail}"
					height="90"
					width="90"
					alt={product.name}
					title={product.name}
				/>
			{:else if product.image && product.image !== 'no_selection'}
				<img src="{PUBLIC_BIXOTO_MEDIA}{product.image}" alt={product.name} title={product.name} />
			{/if}
		</div>

		<div class="cart-card__content">
			<!-- BX. fix for configurable products -->
			{#if product.image === 'no_selection'}
				<h3 class="no-image">{product.name}</h3>
			{:else}
				<a
					on:click={() => ($storeMiniCartModal = false)}
					href="/{scope}/p/{product.url_key}"
					class="cart-card__link"
				>
					<h3>{product.name}</h3>
				</a>
			{/if}

			<div class="cart-card__bottom">
				<QtySelector bind:qty prod={product} />

				{#if special_price && special_price < regular_price}
					<div class="price">
						{getFormattedPrice(special_price * product.cart_qty)} €
					</div>
				{:else}
					<div class="price">
						{getFormattedPrice(regular_price * product.cart_qty)} €
					</div>
				{/if}
			</div>
		</div>
	</div>
</div>

<style lang="scss">
  .cart-card {
    display: block;
    margin-bottom: 12px;

    button.icon-cross {
      position: absolute;
      right: 5px;
      top: 5px;
      color: var(--grey--b);
      font-size: 16px;
      padding: 10px;

      &:hover {
        color: var(--main);
      }
    }

    &__inner {
      position: relative;
      display: flex;
      padding: 12px;
      background: white;
      box-shadow: 0px 0px 17px 5px rgba(0, 0, 0, 0.06);

      img {
        display: flex;
        width: 90px;
      }

      h3 {
        color: var(--black);
        font-size: 16px;
        transition: all linear 0.125s;

        &.no-image {
          margin-right: 30px;
        }
      }
    }

    &__content {
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;

      a {
        &:hover {
          h3 {
            color: var(--main);
          }
        }
      }
    }

    &__link {
      margin-right: 30px;
    }

    &__bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .price {
        font-size: 20px;
        font-weight: 700;
        color: var(--main);

        @media (max-width: 400px) {
          font-size: 18px;
        }
      }
    }
  }
</style>
